import React from 'react';

class MarketSelector extends React.Component {

	render() {
        let { onChange, value, list } = this.props;

        return (
            <select
                className='market-selector'
                onChange={onChange}
                value={value}>

                { list && list.length ? list.map( item =>
                    <option key={'marksel_'+item.id} value={item.id}>{item.name}</option>
                ) : null }
            </select>
        )
    }
}

export default MarketSelector;



// WEBPACK FOOTER //
// ./source/components/marketSelector.js